/**
 * Created by Denis Kuzin on 15 february 2022
 */

const ClansJoinTab = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.setContentSize2(options.width, options.height);

        this.createTableBg();
        this.createTable();
        this.createTransparentBorder();
        this.createSearch();
        this.createNewClanButton();
        this.createAutofitButton();

        cleverapps.clans.onClansListRefreshed = this.createListener(this.createTable.bind(this));
    },

    createTableBg: function () {
        const styles = cleverapps.styles.ClansJoinTab;

        const rect = cc.rectSubPadding(cc.rect(0, 0, this.width, this.height), cc.padding(styles.padding));

        const tableBg = this.tableBg = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        tableBg.setContentSize2(rect.width, rect.height);
        tableBg.setAnchorPoint(0, 0);
        tableBg.setAlignment(rect.x, rect.y);
        this.addChild(tableBg);

        const foreground = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_fg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        foreground.setContentSize2(tableBg.width, tableBg.height);
        foreground.setAnchorPoint(0, 0);
        foreground.setAlignment(0, 0);
        tableBg.addChild(foreground, 1);
    },

    createTable: function () {
        const styles = cleverapps.styles.ClansJoinTab.table;

        const rect = cc.rectSubPadding(cc.rect(0, 0, this.tableBg.width, this.tableBg.height), cc.padding(styles.padding));

        if (this.tableView) {
            this.tableView.removeFromParent();
        }

        const dataSource = StaticDataSource(() => cleverapps.clans.listClans().map((clan, index) => ({
            id: clan.id,
            data: {
                clan,
                place: index + 1,
                emblem: clan.emblem,
                name: clan.name
            }
        })));

        const table = new ScrollTable(dataSource, { parentView: this });
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: true
        });

        new TableHandler(table, tableView, {
            id: "joinClans",
            height: rect.height,
            rowConstructor: ClansJoinRow,
            innerPadding: styles.innerPadding
        });

        tableView.setAlignment(rect.x + rect.width / 2, rect.y + rect.height / 2);
        this.tableBg.addChild(tableView);
    },

    createTransparentBorder: function () {
        if (!bundles.clans_window.frames.transparent_border) {
            return;
        }

        const styles = cleverapps.styles.ClansJoinTab.transparentBorder;

        const transparentBorder = cleverapps.UI.createScale9Sprite(bundles.clans_window.frames.transparent_border, cleverapps.UI.Scale9Rect.TwoPixelXY);
        transparentBorder.setContentSize(styles.width, styles.height);
        transparentBorder.setAlignment(styles);
        this.addChild(transparentBorder);
    },

    createSearch: function () {
        const styles = cleverapps.styles.ClansJoinTab.search;

        const bg = cleverapps.UI.createScale9Sprite(bundles.clans_window.frames.search_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(styles.bg.width, styles.bg.height);

        const placeholder = cleverapps.UI.generateOnlyText(Messages.get("ClansJoinTab.search_placeholder"), cleverapps.styles.FONTS.CLAN_EDIT_TEXT);
        placeholder.fitTo(styles.placeholder.width);
        placeholder.setAlignment(styles.placeholder);
        placeholder.setOpacity(140);
        bg.addChild(placeholder);

        const editBox = this.editBox = new cc.EditBox(cc.size(styles.editbox.width, styles.editbox.height), undefined, true);
        editBox.setMaxLength(styles.editbox.maxLength);
        editBox.setString(" ");
        editBox.setDelegate(this);
        editBox.stayOnTop(true);
        editBox.setTouchEnabled();
        editBox.setFontSize(cleverapps.styles.FONTS.CLAN_EDIT_TEXT.size);
        editBox.setFontColor(cleverapps.styles.FONTS.CLAN_EDIT_TEXT.color);
        editBox.setFontName(cleverapps.UI.getFontName());
        editBox.setString("");
        editBox.setAlignment(styles.editbox);
        editBox.customPlaceholder = placeholder;
        bg.addChild(editBox);

        bg.setAlignment(styles.bg);
        this.addChild(bg);

        const searchButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            text: "%%",
            icons: {
                "%%": bundles.clans_window.frames.magnifier_icon
            },
            onClicked: this.startSearch.bind(this)
        });
        searchButton.setAlignment(styles.button);
        this.addChild(searchButton);
    },

    startSearch: function () {
        let teamName = this.editBox.getString();
        teamName = teamName.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, "");

        if (this.lastTeamName !== teamName) {
            this.lastTeamName = teamName;

            this.editBox.stayOnTop(false);
            this.editBox.setFontSize(cleverapps.styles.FONTS.CLAN_EDIT_TEXT.size);
            this.editBox.setFontColor(cleverapps.styles.FONTS.CLAN_EDIT_TEXT.color);
            this.editBox.setFontName(cleverapps.UI.getFontName());

            cleverapps.clans.search(teamName, () => {
                this.editBox.stayOnTop(true);
            });
        }
    },

    createNewClanButton: function () {
        const styles = cleverapps.styles.ClansJoinTab.createClanButton;

        const text = cleverapps.UI.generateOnlyText(Messages.get("Create"), cleverapps.styles.FONTS.BUTTON_TEXT);
        const plus = new cc.Sprite(bundles.clans_window.frames.plus_icon);
        const content = new cleverapps.Layout([text, plus], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        const createClanButton = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: styles.type,
            content,
            onClicked: function () {
                cleverapps.focusManager.display({
                    focus: "AddClanWindow",
                    stack: true,
                    action: function (f) {
                        new AddClanWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
        createClanButton.setAlignment(styles);
        this.addChild(createClanButton);
    },

    createAutofitButton: function () {
        const styles = cleverapps.styles.ClansJoinTab;

        const text = cleverapps.UI.generateOnlyText(Messages.get("ClansJoinTab.autoFitButton"), cleverapps.styles.FONTS.BUTTON_TEXT);
        const icon = new cc.Sprite(bundles.clans_window.frames.team_icon);
        const content = new cleverapps.Layout([icon, text], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        const autofitButton = new cleverapps.UI.Button({
            width: styles.autofitButton.width,
            height: styles.autofitButton.height,
            type: cleverapps.styles.UI.Button.Images.button_green,
            content,
            onClicked: function () {
                cleverapps.clans.autofit();
            }
        });
        autofitButton.setAlignment(styles.autofitButton);
        this.addChild(autofitButton);
    },

    onSelectTab: function () {
        this.editBox.stayOnTop(true);
    },

    onUnSelectTab: function () {
        this.editBox.stayOnTop(false);
    },

    editBoxEditingDidBegin: function (sender) {
        sender.customPlaceholder.setVisible(false);
    },

    editBoxEditingDidEnd: function (sender) {
        if (sender.getString() === "") {
            sender.customPlaceholder.setVisible(true);
        }
    },

    editBoxTextChanged: function (sender, text) {
        if (this._textBeforeReturn || text === "\n") {
            sender.setString(this._textBeforeReturn || "");
            this._textBeforeReturn = undefined;

            this.startSearch();
        }
    },

    editBoxReturn: function (sender) {
        this._textBeforeReturn = sender.getString();

        sender.setString("");
    }
});

cleverapps.styles.ClansJoinTab = {
    margin: 10,
    padding: {
        x: -30,
        top: -10,
        bottom: 100
    },

    createClanButton: {
        margin: 10,
        width: 260,
        height: 80,
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -16 },
        type: cleverapps.styles.UI.Button.Images.button_blue
    },

    autofitButton: {
        width: 300,
        height: 90,
        x: { align: "center" },
        y: { align: "bottom", dy: -5 }
    },

    table: {
        padding: {
            x: 0,
            top: 130,
            bottom: 20
        }
    },

    search: {
        bg: {
            width: 630,
            height: 84,
            x: { align: "left", dx: 95 },
            y: { align: "top", dy: -13 }
        },

        editbox: {
            width: 585,
            height: 72,
            maxLength: 25,
            x: { align: "center", dx: 5 },
            y: { align: "center", dy: 0 }
        },

        placeholder: {
            width: 580,
            x: { align: "center", dx: 10 },
            y: { align: "center", dy: 0 }
        },

        button: {
            width: 100,
            height: 100,
            x: { align: "left", dx: 20 },
            y: { align: "top", dy: -5 }
        }
    },

    transparentBorder: {
        width: 1300,
        height: 41,
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -90 }
    }
};